export default __webpack_public_path__ + "static/media/dog.03e7f16b.jpg";